import {
  GET_ORDER_REQUEST,
  GET_ORDER_BY_EMAIL_ORDERNUMBER_REQUEST,
  LIST_ORDERS_REQUEST,
  RESET_ORDER_QUERY
} from './constants';

export const listOrders = (queryString) => ({
  type: LIST_ORDERS_REQUEST,
  queryString
});

export const getOrder = (orderId) => ({ type: GET_ORDER_REQUEST, orderId });

export const getOrderByEmailOrderNumber = (email, orderNumber) => ({
  type: GET_ORDER_BY_EMAIL_ORDERNUMBER_REQUEST,
  email,
  orderNumber
});

export const resetOrderQuery = () => ({
  type: RESET_ORDER_QUERY
});
